import React from 'react'

import { Grid as BaseGrid, styled } from '@mui/material'

export const Root = styled('div')`
  width: 100%;
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.gray[50]};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  height: 20px;
  letter-spacing: 0;
  line-height: 20px;
  width: 57px;

  &::before {
    content: '<';
    margin-right: 15px;
  }
`

export const Row = styled(({ alignItems = false, background = false, border = false, margin, ...props }) => (
  <BaseGrid {...props} />
))`
  margin: ${props => props.margin || '0 -5px'};
  width: 100%;
  background-color: ${props => props.background && props.theme.palette.green[95]};
  border: ${props => props.border && '1px solid'};
  border-color: ${props => props.border && props.theme.palette.green[75]};
  padding: ${props => props.padding && '2px'};
  align-items: ${props => props.alignItems && 'center'};
`
